var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46902 19.9999C2.69863 19.9999 2.21758 19.1654 2.60366 18.4988L11.0035 3.99428C11.3887 3.32914 12.349 3.32914 12.7342 3.99428L21.1341 18.4988C21.5202 19.1654 21.0391 19.9999 20.2687 19.9999H3.46902ZM4.31887 18.4999H19.4189L11.8689 5.49993L4.31887 18.4999ZM11.8689 17.3076C12.0977 17.3076 12.2895 17.2302 12.4443 17.0754C12.5991 16.9206 12.6765 16.7288 12.6765 16.4999C12.6765 16.2711 12.5991 16.0793 12.4443 15.9245C12.2895 15.7697 12.0977 15.6923 11.8689 15.6923C11.64 15.6923 11.4482 15.7697 11.2934 15.9245C11.1386 16.0793 11.0612 16.2711 11.0612 16.4999C11.0612 16.7288 11.1386 16.9206 11.2934 17.0754C11.4482 17.2302 11.64 17.3076 11.8689 17.3076ZM11.1189 14.6923H12.6188V9.69226H11.1189V14.6923Z",
    fill: "#F87700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.79efd064f56f7c529f94e27674dc1f4e.svg";
export { ForwardRef as ReactComponent };